/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import fondo from '../Recursos/fondo_footer.svg'
import logo from '../Recursos/logo_claro.png'
import fondo_derechos from '../Recursos/fondo_derechos.svg'
import {CONTACTOS, REDES, SECCIONES} from "../Constantes";
import {theme} from "../Tema";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";


const Footer = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center'
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6, mb: 8}}>
                            <img src={logo} width={100} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 4, md: 4}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 600}}>Enlaces Directos</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 1}}
                                >

                                    {links.map((item, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography>{item}</Typography>
                                            </Grid>
                                        )
                                    })}

                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={sCell ? 1 : 2}
                                    sx={{mt: 2}}
                                >


                                    {REDES.map((item, index) => {
                                        return (
                                            <IconButton>
                                                <img src={item.img} width={sCell ? 32 : 42}/>
                                            </IconButton>
                                        )
                                    })}

                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 600}}>Menu</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'center'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 1}}
                                >

                                    {SECCIONES.map((item, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center', mt: 1}}>
                                                <Typography sx={{fontSize: 14}}>{item}</Typography>
                                            </Grid>
                                        )
                                    })}

                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={sCell ? 'center' : 'flex-end'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-end'}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 600}}>Datos de Contacto</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 1}}
                                >

                                    {CONTACTOS.map((item, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: 1}}>
                                                <Typography sx={{
                                                    textAlign: sCell ? 'center' : 'right',
                                                    fontSize: 14
                                                }}>{item.descripcion}</Typography>
                                            </Grid>
                                        )
                                    })}

                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    background: `url(${fondo_derechos})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'top center',
                                    py: 4
                                }}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                                    <Typography
                                        sx={{color: theme.palette.primary.main, fontWeight: 600, textAlign: 'center'}}>2026
                                        - 2027 ©
                                        Todos los derechos
                                        reservados</Typography>
                                </Grid>


                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer

const links = ['Reservar Habitación', 'Mapa Ubicación']

